/**
 * Required Imports - Third Parties
 */
window.jQuery = require('jquery');
window.$ = window.jQuery;
window.paJsVersion = '1.0.0.0';

import 'lazysizes';

require('bootstrap/dist/js/bootstrap.js');

/**
 * Required Imports - Third Parties
 */
require('./libraries/jquery-ui-datepicker/jquery-ui-datepicker.js');
require('owl.carousel2/dist/owl.carousel.js');
require('cookieconsent/build/cookieconsent.min.js');
require('jquery-validation/dist/jquery.validate.js');

require('./helper.js');
require('./mega-menu.js');
require('./collapsible-sections.js');
require('./find-project.js');
require('./forms.js');
require('./share-links.js');
require('./faqs.js');
require('./snippets');
require('./owl-carousel.js');
require('./trip-format.js');
require('./staff-profiles');
require('./product.js');
require('./announcement-banner.js?v=2');
require('./bs-ios-modal-fix.js');
require('./js-jump-links.js');
require('./prices.js');
// require('./optimize-experiments.js'); // A/B Testing

/**
 * Main.js logic
 * (TODO: This ideally wants refactoring to separate modules)
 */

jQuery(function($) {
    /**
     * Headings fallback if no hero img
     */
    //
    let heroImgURL = $('.Hero .container img').attr('src');

    if (typeof heroImgURL === 'undefined') {
        $('.top').addClass('Fallback');
        $('.Hero').addClass('Fallback');
        $('.main-content').addClass('Fallback');
    }

    /**
     * Remove empty paragraphs that might come from CMS
     * <p><br><p>
     */

    jQuery('p').each(function() {
        var trimmedP = jQuery.trim(jQuery(this).html());
        if (trimmedP === '<br>') {
            jQuery(this).remove();
        }
        if (trimmedP === '&nbsp;') {
            jQuery(this).remove();
        }
    });
    
    jQuery('.ModalProjectOverview').on('show.bs.modal', function() {
        if (window.innerWidth < 900) {
            jQuery('#hubspot-messages-iframe-container').addClass('js-livechat-hidden');
            jQuery(this).one('hide.bs.modal', function() {
                jQuery('#hubspot-messages-iframe-container').removeClass('js-livechat-hidden');
            });
        }
    });
});